import React from 'react';
import { Row, Col, Input, Button } from 'antd';
import './index.less';
import arrow from '../../img/solution/arrow.png';
import arrow2 from '../../img/solution/arrow2.png';
import topbj from '../../img/about/topbj.png';
import culture1 from '../../img/forwarder/1.jpg';
import culture4 from '../../img/forwarder/4.png';
import img1 from '../../img/forwarder/f/1.png';
import img2 from '../../img/forwarder/f/2.png';
import img3 from '../../img/forwarder/f/3.png';
import img4 from '../../img/forwarder/f/4.png';
import img5 from '../../img/forwarder/f/5.png';
import img6 from '../../img/forwarder/f/6.png';
import img7 from '../../img/forwarder/f/7.jpg';
import new_topic from '../../img/forwarder/new_topic.png';
import httpDataList from './httpData';
import moment from 'moment';
export default class Forwarder extends React.Component {
  state = {
    img1: img1,
    img2: img2,
    img3: img3,
    img4: img4,
    img5: img5,
    img6: img6,
    img7: img7,
    httpDataList: [],
    info: {},
    value1: '',
    value2: '',
    userInfo: null,
    hwInfo:null
  };
  constructor(props) {
    super(props);
  }
  handleClick(info) {
    if (info === 'bottomjava') {
      document.getElementById('bottomjava').className = 'hiden';
      document.getElementById('leftjava').className = 'show';
      document.getElementById('java-describe').className = 'job-describe hiden';
    } else if (info === 'leftjava') {
      document.getElementById('bottomjava').className = 'show';
      document.getElementById('leftjava').className = 'hiden';
      document.getElementById('java-describe').className = 'job-describe show';
    } else if (info === 'leftfront') {
      document.getElementById('bottomfront').className = 'show';
      document.getElementById('leftfront').className = 'hiden';
      document.getElementById('front-describe').className = 'job-describe show';
    } else {
      document.getElementById('leftfront').className = 'show';
      document.getElementById('bottomfront').className = 'hiden';
      document.getElementById('front-describe').className =
        'job-describe hiden';
    }
  }
  getUrlParams(name) {
    // 不传name返回所有值，否则返回对应值
    var url = window.location.href;
    if (url.indexOf('?') == -1) {
      return false;
    }
    url = url.substr(url.indexOf('?') + 1);
    url = url.split('&');
    var name = name || '';
    var nameres;
    // 获取全部参数及其值
    for (var i = 0; i < url.length; i++) {
      var info = url[i].split('=');
      var obj = {};
      obj[info[0]] = decodeURI(info[1]);
      url[i] = obj;
    }
    // 如果传入一个参数名称，就匹配其值
    if (name) {
      for (var i = 0; i < url.length; i++) {
        for (const key in url[i]) {
          if (key == name) {
            nameres = url[i][key];
          }
        }
      }
    } else {
      nameres = url;
    }
    // 返回结果
    return nameres;
  }

  componentWillMount () {
    setTimeout(() => {
      let antMenu = document.getElementsByClassName('ant-menu')
      console.log(antMenu)
      console.log(antMenu[0])
      let lis = antMenu[0].childNodes
      lis[3].setAttribute('class','ant-menu-item')
      lis[5].setAttribute('class','ant-menu-item ant-menu-item-selected')
    }, 0);

    

    let id = Math.floor(Math.random() * 10 + 1);
    this.setState({ httpDataList: httpDataList[`${id}`] });
    console.log('id=>' + id);

    let sInfo=window.localStorage.getItem('_dr_');
    if(sInfo){
      this.setState({hwInfo:JSON.parse(sInfo)})
      console.log(JSON.parse(sInfo))
    }else{
      alert('数据获取异常')
      window.location.href="/"
    }

  }
  orderReceivingHandleClick(item) {
    console.log(item);

    let userInfo = window.localStorage.getItem('_u_');
    console.log(userInfo);
    if (!userInfo) {
      alert('请先登录，再进行接单');
      document.getElementById('ulogin').style.display = 'block';
      return;
    } else {
      this.setState({ userInfo: JSON.parse(userInfo) });
    }

    this.setState({ info: item });
    document.getElementById('modal').style.display = 'block';
  }
  formatDate() {
    return moment().format('YYYY-MM-DD');
  }
  submitData() {
    if (document.getElementById('chepai').value === '') {
      alert('请输入车牌');
      return;
    }

    if (!this.isVehicleNumber(document.getElementById('chepai').value)) {
      alert('车牌号格式错误');
      return;
    }

    if (document.getElementById('baojia').value === '') {
      alert('请输入意向报价');
      return;
    }

    var patten = /^[+-]?(0|([1-9]\d*))(\.\d+)?$/g;
    if (!patten.test(document.getElementById('baojia').value)) {
      alert('意向报价请输入数字');
      return;
    }
    if (window.confirm('确定接单？')) {
      let order = window.localStorage.getItem('_o_');
      let orderJson = [];
      let isexists = false;
      if (order) {
        orderJson = JSON.parse(order);
        isexists =
          orderJson.findIndex((v) => v.id === this.state.info.id) === -1
            ? false
            : true;
        if (isexists) {
          setTimeout(() => {
            alert('您已接过此单，不能重复接单');
          }, 1000);
          return;
        }
      }

      setTimeout(() => {
        orderJson.push(
          Object.assign(this.state.info, {
            chepai: document.getElementById('chepai').value,
            chechang: document.getElementById('chechang').value,
            zaizhong: document.getElementById('zaizhong').value,
            tiji: document.getElementById('tiji').value,
            baojia: document.getElementById('baojia').value,
            createDate: new Date().getTime(),
          })
        );
        window.localStorage.setItem('_o_', JSON.stringify(orderJson));
        alert('接单成功，请保持电话畅通，货主稍候会联系您！');
        document.getElementById('modal').style.display = 'none';
      }, 500);
    }
  }
  //车牌号验证方法

  isVehicleNumber(vehicleNumber) {
    var xreg = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}(([0-9]{5}[DF]$)|([DF][A-HJ-NP-Z0-9][0-9]{4}$))/;

    var creg = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳]{1}$/;

    if (vehicleNumber.length == 7) {
      return creg.test(vehicleNumber);
    } else if (vehicleNumber.length == 8) {
      return xreg.test(vehicleNumber);
    } else {
      return false;
    }
  }
  login() {
    if (document.getElementById('tijiao').value === '登录中...') {
      return;
    }
    let account = document.getElementById('account').value;
    let password = document.getElementById('password').value;

    if (account === '') {
      alert('请输入登录名/手机号');
      return;
    }

    if (password === '') {
      alert('请输入密码');
      return;
    }

    let localStorage = window.localStorage.getItem('_i_');
    if (localStorage) {
      let obj = JSON.parse(localStorage);
      let phoneExists = obj.findIndex(
        (v) => v.phone === account || v.u === account
      );
      if (phoneExists === -1) {
        alert('此用户名/手机号不存在，请先注册账号');
        return;
      } else {
        let acc = obj.filter((v) => v.phone === account || v.u === account);

        let p2 = acc.findIndex(
          (v) => (v.phone === account || v.u === account) && v.p === password
        );
        if (p2 === -1) {
          alert('密码错误');
          return;
        }
      }
      let lr = document.getElementById('lr');
      let un = document.getElementById('un');
      let myOrder = document.getElementById('myOrder');
      lr.style.display = 'none';
      un.innerHTML = account;
      myOrder.style.display = 'block';
      window.localStorage.setItem(
        '_u_',
        JSON.stringify({ u: account, d: new Date().getTime() })
      );
      this.setState({ userInfo: { u: account, d: new Date().getTime() } });
      document.getElementById('tijiao').value = '登录中...';
      setTimeout(() => {
        alert('登录成功');
      }, 1000);
      document.getElementById('ulogin').style.display = 'none';
    } else {
      alert('此用户名/手机号不存在，请先注册账号');
      return;
    }
  }
  handleChange1 = (e) => {
    console.log(e);
    const { value } = e.target;
  };
  handleChange2(e) {
    const { value } = e.target;
    this.setState({ value2: value });
  }
  render() {
    var res1 = this.getUrlParams('id');
    let dataList = [
      {
        pic: this.state.img1,
        name: '东莞市金玛物流有限公司',
        line: '东莞 → 上海',
        desc:
          '介绍：东莞市金玛物流有限公司承接东莞至全国整车零担货物运输，自备4.2米到17.5米大小车',
        address:
          '东莞市大朗镇康丰路巷头社区大朗物流中心三期C30-36号',
        time: '2天',
        money: '面议',
        dengji: '2',
        xianlu: ['东莞→临沂', '东莞→郑州', '东莞→长沙'],
        lianxiren: '唐经理',
        jieshao:
          '东莞市金玛物流有限公司（公司承接东莞专线往返江苏 浙江 上海全境 等全国各地的整车、零担货运业务，特快专线，天天发车 竭诚为您服务！ 东莞市金玛物流有限公司是东莞市一家集零担快运、物流配送、车辆挂靠为一体的专业货运公司。公司自备车队及专业吊装设备，为广大客户提供专业化、大规模、全方位的物流服务。公司技术力量雄厚，具有多名**物流师，可为各类企业设计专业的物流方案。 倡导“以人为本”的企业文化，在不断积累物流经验的同时，培养了大批对各地物流市场和物流知识非常熟悉的专业人才，并引进了一批高层次的物流人才和管理人才，形成了创新、务实、专业的管理团队。**的管理团队，成就了可持续发展，在为客户提供超值服务的同时，也保证了行业**地位。 东莞市金玛物流有限公司将以客户需求为中心，完善基础管理，成为国内消费品销售物流服务领域的***；以技术专业化、服务差异化、平台规模化、经营精细化，实现为更多的客户提供超值服务，与更多地客户结成战略伙伴；以人为本体现真诚，以**的团队成就前瞻的专业物流公司，将为成就*有影响力的物流服务品牌而努力前行',
        zhuyingxianlu: [
          {
            xianlu: '广东 东莞  → 河南 郑州 ',
            dun: '400元/吨',
            shixiao: '3天',
            fang: '100元/立方',
          },
          {
            xianlu: '广东 东莞  → 山东 临沂  ',
            dun: '400元/吨',
            shixiao: '4天',
            fang: '100元/立方',
          },
          {
            xianlu: '广东 东莞  → 湖南 长沙  ',
            dun: '300元/吨',
            shixiao: '不祥',
            fang: '120元/立方',
          },
          {
            xianlu: '广东 东莞  → 云南 昆明  ',
            dun: '550元/吨',
            shixiao: '不祥',
            fang: '160元/立方',
          },
        ],
      },
      {
        pic: this.state.img2,
        name: '东莞市菜鸟仓储物流有限公司',
        line: '北京 → 广州',
        desc:
          '简介：东莞市菜鸟仓储物流有限公司（菜鸟智能物流）承接广东珠三角地区到全国各地整车零担货物运',
        address:
          '地址一：东莞市高步镇北王路百茂物流园',
        time: '3天',
        money: '1400元',
        dengji: '3',
        xianlu: ['东莞→昆明', '东莞→济南', '东莞→金华'],
        lianxiren: '李经理',
        jieshao:
          '东莞市菜鸟仓储物流有限公司（菜鸟智能物流）承接广东珠三角地区到全国各地整车零担货物运输。公司自备车队及专业吊装设备，为广大客户提供专业化、大规模、全方位的物流服务。大票零担物流领导品牌-菜鸟智能物流:通过创新性信息技术、物联网技术、大数据技术、区块链和人工智能技术等改变传统供应链中的各个运营环节，提升运行效率、降低运行成本、实现供应链各环节的集成，满足中小企业碎片化物流运作需求，真正实现“省事省心更省钱”',
        zhuyingxianlu: [
          {
            xianlu: '广东 东莞  → 云南 昆明',
            dun: '520元/吨',
            shixiao: '3天',
            fang: '155元/立方',
          },
          {
            xianlu: '广东 东莞  → 山东 济南',
            dun: '470元/吨',
            shixiao: '不祥',
            fang: '140元/立方',
          },
          {
            xianlu: '广东 东莞  → 浙江 金华',
            dun: '540元/吨',
            shixiao: '不祥',
            fang: '160元/立方',
          },
          {
            xianlu: '广东 东莞  → 山东 青岛',
            dun: '470元/吨',
            shixiao: '不祥',
            fang: '160元/立方',
          },
        ],
      },
      {
        pic: this.state.img3,
        name: '广州创盛物流有限公司',
        line: '广州 → 上海',
        desc:
          '简介：广州创盛物流有限公司，自成立以来以优先的技术专业，严格的操作安全，自强不息的严格管理',
        address: '广州市白云区龙陂口北街锦邦货运市场',
        time: '1天',
        money: '面议',
        dengji: '2',
        xianlu: ['广州→大连', '广州→银川', '广州→成都'],
        lianxiren: '魏经理',
        jieshao:
          ' 广州创盛物流有限公司，自成立以来以优先的技术专业，严格的操作安全，自强不息的严格管理，优质服务的合作伙伴，秉承“创新守信，稳健求是，博才广进，开拓进取”的经营理念，深化内部改革，转变经营机制，强化科技兴企，夯实基础管理，使企业综合实力达到了同行业前茅。公司一直以来都注重国有大、中、小企业提供了安全、优质的服务，并且建立了长期良好的合作关系并赢得广大客户的信赖和好评。广接全国各地的整车、零担运输业。价格优惠、全程保险，配送及时。广州创盛物流有限公司是一家综合服务型物流运输企业，专业从事国内普货及危险品运输、机械大件运输、易碎品运输和航空运输代理等。公司以专业臻**，以安全做保障，以快速求发展为宗',
        zhuyingxianlu: [
          {
            xianlu: '广东 广州  → 辽宁 大连',
            dun: '300元/吨',
            shixiao: '2天',
            fang: '100元/立方',
          },
          {
            xianlu: '广东 广州  → 宁夏 银川',
            dun: '300元/吨',
            shixiao: '不祥',
            fang: '100元/立方',
          },
          {
            xianlu: '广东 广州  → 四川 成都',
            dun: '300元/吨',
            shixiao: '1天',
            fang: '100元/立方',
          },
          {
            xianlu: '广东 广州  → 辽宁 沈阳',
            dun: '300元/吨',
            shixiao: '不祥',
            fang: '100元/立方',
          },
        ],
      },
      {
        pic: this.state.img4,
        name: '江西威凯物流有限公司广州业务部',
        line: '广州 → 上海',
        desc:
          '简介：江西威凯物流有限公司广州业务部为您提供零担运输、整车运输等服务。运营及合作货运专线覆',
        address: '广州市大源北路林安物流园物联网中心6楼613室',
        time: '2天',
        money: '面议',
        dengji: '4',
        xianlu: ['广州→成都', '广州→成都', '广州→重庆'],
        lianxiren: '揭经理',
        jieshao:
          '江西威凯物流有限公司广州业务部为您提供零担运输、整车运输等服务。运营及合作货运专线覆盖全国200多个城市。保证货物安全、快速、准时到达目的地。我们致力于打造为讲诚信、服务好、价格合理的货运专线公司。诚实守信是公司的灵魂！安全快捷是公司的命脉！贴心服务是公司的文化！您的满意是公司的追求！本公司从不同角度为顾客考虑到每一个细小的环节，做到尽可能满足顾客需要，又不会让您考虑费用上的负担，为您带来超值服务。公司以“敬职敬业、真诚服务”为服务宗旨，以服务用户为目标，积极探索，不断创新，努力开创物流行业新楷模。随着公司业务扩展，公司不断朝集团化，规模化方向发展。在此真诚期望能结识更多的合作伙伴，相信我们的强强联合将使我们的商路越走越远。',
        zhuyingxianlu: [
          {
            xianlu: '广东 广州  → 四川 成都 ',
            dun: '280元/吨',
            shixiao: '2天',
            fang: '120元/立方',
          },
          {
            xianlu: '广东 广州  → 辽宁 沈阳 ',
            dun: '280元/吨',
            shixiao: '不祥',
            fang: '120元/立方',
          },
          {
            xianlu: '广东 广州  → 重庆 重庆 ',
            dun: '280元/吨',
            shixiao: '1天',
            fang: '120元/立方',
          },
          {
            xianlu: '广东 广州  → 江西 南昌 ',
            dun: '280元/吨',
            shixiao: '不祥',
            fang: '120元/立方',
          },
        ],
      },
      {
        pic: this.state.img5,
        name: '天津市百利东升物流有限公司',
        line: '天津 → 郑州',
        desc:
          '简介：【天津市百利东升物流有限公司】是一家长途运输公司物流网络覆盖全国大中城市承接天津至全',
        address: '天津市北辰区佳丰道华北集团成邦物流园',
        time: '2天',
        money: '面议',
        dengji: '2',
        xianlu: ['天津→临沂', '天津→杭州', '天津→长春'],
        lianxiren: '石经理',
        jieshao:
          ' 公司主要经营到全国的货运服务，有着丰富的物流实际操作经验、完善的监督机制及规章制度，实现了管理化、服务化、规范化、信息化目标。 公司有平板、高栏、厢车，特种托运车辆，以线路多元化，降低运输成本，以低廉的优势和货运公司现代化的货运理念，为您提供*全面的物流服务。 公司秉承“诚信为本、价优高效”的经营理念，提倡“以客为尊”的服务宗旨，贯彻“专业化人才、专业化服务、学习型团队企业”的管理思想，创建**的中国物流企业。公司将继续不断的提升服务质量、强化服务功能，为广大新老客户提供*优质的货物运输方案。服务规范:优良的货运服务讲求速度，准确及专业的服务知识。经过多年的努力不懈，我司已备一切成为物流公司的先决条件。同时与业内其它公司保持紧密及良好的业务关系获得他们的支持，保证提供充足的货物装载位置托运货物，我公司的专业员工将以快捷有效的方案完成顾客所托货物安全准时运抵目的地。',
        zhuyingxianlu: [
          {
            xianlu: '天津  → 河南 郑州 ',
            dun: '280元/吨',
            shixiao: '2天',
            fang: '120元/立方',
          },
          {
            xianlu: '天津  → 河南 商丘 ',
            dun: '280元/吨',
            shixiao: '不祥',
            fang: '120元/立方',
          },
          {
            xianlu: '天津  → 河南 濮阳 ',
            dun: '280元/吨',
            shixiao: '1天',
            fang: '120元/立方',
          },
          {
            xianlu: '天津  → 河南 开封 ',
            dun: '280元/吨',
            shixiao: '不祥',
            fang: '120元/立方',
          },
        ],
      },
      {
        pic: this.state.img6,
        name: '天津宏泰金通物流有限公司',
        line: '天津 → 河南',
        desc: '简介：主营：天津至河南、广东、上海直达专线；   天津到河南专线：',
        address: '天津市北辰区红旗路北兴物流园内',
        time: '3天',
        money: '面议',
        dengji: '3',
        xianlu: ['天津→上海', '天津→重庆', '天津→郑州'],
        lianxiren: '何经理',
        jieshao:
          '天津宏泰金通物流有限公司是由天津运管部门批准，专门从事全国各地运输服务的物流企业。本公司拥有一批专业的管理人员和专业的运输队伍，以严格，科学的管理手段，现代化的办公设施，为客户提供*优质的服务。公司主要以公路运输为主，专业从事公路运输、长途搬家、物流专线、货物运输、危险品运输、道路集装箱运输、道路普通货物运输、国内货运代理、仓储、配送、快递、搬家迁厂、大型设备吊、危险品运输、特殊车辆运输服务，我公司现拥有4.2—17.5米各种类型的大小运输车辆，整车零担均可，为您提供全方位的物流服务，24小时为您提供货物查询，业务咨询，信息反馈，监督的服务，实现了诚信，准时，安全，便利的服务目标，赢得了全国广大客户的支持和信赖。随着公司业务扩展，与国内多家运输公司建立了兄弟联运业务，使公司不断朝集团化，规模化方向发展。热烈期望能结识更多的合作伙伴，相信我们的强强联合将使我们的商路越走越远! 天津到哈尔滨专线、天津到长春专线、天津到沈阳专线、天津到呼和浩特专线、天津到乌鲁木齐专线、天津到兰州专线、天津到银川专线、天津到西安专线、天津到太原专线、天津到石家庄专线、天津到北京专线、天津到济南专线、天津到郑州专线、天津到南京专线、天津到合肥专线、天津到武汉专线、天津到重庆专线、天津到成都专线、天津到昆明专线、天津到南宁专线、天津到广州专线、天津到贵阳专线、天津到长沙专线、天津到南昌专线、天津到上海专线、天津到杭州专线、天津到福州专线、天津到海口专线。',
        zhuyingxianlu: [
          {
            xianlu: '天津 天津  → 上海 上海 ',
            dun: '240元/吨',
            shixiao: '2天',
            fang: '80元/立方',
          },
          {
            xianlu: '天津 天津  → 重庆 重庆 ',
            dun: '420元/吨',
            shixiao: '不祥',
            fang: '130元/立方',
          },
          {
            xianlu: '天津 天津  → 河南 郑州 ',
            dun: '180元/吨',
            shixiao: '1天',
            fang: '80元/立方',
          },
          {
            xianlu: '天津 天津  → 山东 青岛 ',
            dun: '110元/吨',
            shixiao: '1天',
            fang: '60元/立方',
          },
        ],
      },
      {
        pic: this.state.img7,
        name: '山西转型综改示范区阳曲园区京大货运部',
        line: '太原 → 北京',
        desc:
          '简介：太原市俊文货运中心货运中心承接全国各地整车、零担运输、轿车运输、长途搬家、包装等业务',
        address: '山西综改示范区太原阳曲园区松庄路2号院南门1-3号库',
        time: '4天',
        money: '面议',
        dengji: '4',
        xianlu: ['太原→石家庄', '太原→西安', '太原→天津'],
        lianxiren: '韩经理',
        jieshao:
          '山西转型综改示范区阳曲园区京大货运部专业承接电动车托运，摩托车托运，大件设备托运，行李托运，搬家打包服务，工地搬家，钢琴托运，上门取货，送货上门，校园行李托运。配备经验丰富的操作员，强大的货物信息跟踪系统，秉承至诚至信、精益求精的全新企业理念为客户服务，力求把较**、较高效、较安全、较快捷、较优惠、较体贴的服务回报给客户。公路运输主要有普通货物整车、零担货运，以太原较优惠的价格，较优质的服务，简便齐全的手续，灵活的结算方式，24小时为您服务，本公司较大优点是：无论货物多少，一票货一人负责到底，让您跟踪货物更省心，我公司秉着“诚实敬业、开拓进取”的精神，应广大客户的需求。另外公司还备有上千平米仓储房，可为顾客提供整车、零担、仓储、包装（现代化打包机，专业人员分理）、代办中转等服务。公司上下秉承诚信的一贯作风，凭着合理的价格，在业内和客户群中赢得了广泛的赞誉和相当的知名度。公司宗旨：信誉至上、优质服务、广交朋友服务承诺：以“诚信、快捷、发展、奉献”的理念，以先进的管理思想，**的管理实践，运用现代化物流管理技术和设备，整合社会物流资源，基于公司干线运输和仓储优势为客户提供超值服务。从太原直达全国各地，以下是我们直达的城市！省内专线-祁县平遥介休长治忻州大同临汾运城省际专线直达：广州、南京、西安华中专线：北京、天津、石家庄、郑州、武汉、长沙华南专线：上海、南昌、南京、杭州、义乌、合肥、济南、青岛西南专线：昆明、南宁、贵阳、遵义、重庆、成都东北专线：哈尔滨、沈阳、大连、长春、吉林、佳木斯西北专线：西安、太原、兰州、西宁、银川、乌鲁木齐沿海专线：海口、汕头、厦门、福州、宁波、温州主营业务：托运,货运代理,报关服务,上门提货,多种车型,起重搬运,车辆托运,公司搬家,限时速运,保险服务,全国,同城,短途,上门提货,送货上门,多种车型,起重搬运,代收货款,代签回单,限时速运,专人负责,保险服务,结算灵活,正规**,24小时服务。',
        zhuyingxianlu: [
          {
            xianlu: '山西 太原  → 河北 石家庄 ',
            dun: '150元/吨',
            shixiao: '2天',
            fang: '50元/立方',
          },
          {
            xianlu: '山西 太原  → 陕西 西安 ',
            dun: '150元/吨',
            shixiao: '不祥',
            fang: '50元/立方',
          },
          {
            xianlu: '山西 太原  → 天津 天津 ',
            dun: '180元/吨',
            shixiao: '1天',
            fang: '80元/立方',
          },
          {
            xianlu: '山西 太原  → 河南 郑州 ',
            dun: '110元/吨',
            shixiao: '1天',
            fang: '60元/立方',
          },
        ],
      },
    ];
    let modalWidth = document.body.clientWidth;
    const { value1, value2 } = this.state;
    return (
      <div style={{ width: '100%' }}>
        <Row className="join-box2"></Row>
        <div style={{ backgroundColor: '#F6F6F6' }} className="paddingBottom30">
          <div className="topNam">
            <div className="top_com">
              <div className="comHeader fl">
                <h1 className="comName cmne">{dataList[res1].name}</h1>
              </div>
              <div className="clear"></div>
            </div>
          </div>
          {/* <div className="container_new">
            <div className="xjj_head clearfloat">
              <img
                src={new_topic}
                className="xjj_topic fl"
                alt="线路运价"
              ></img>
              <div className="xjj-title fl">
                <div className="head_main">
                  <div className="xl_name">
                    {dataList[res1].line}
                    <span className="allph">（支持全国配货）</span>
                  </div>
                </div>
              </div>
            </div>
            <div style={{ width: '100%' }}>
              <div style={{ width: '100%' }} className="branch">
                <div className="branch-t">
                  联系人：{dataList[res1].lianxiren}
                </div>
                <div className="branch-t">地址：{dataList[res1].address}</div>
                <div className="branch-t">运价信息：{dataList[res1].money}</div>
                <div className="branch-t">运输时效：{dataList[res1].time}</div>
              </div>
            </div>
          </div> */}
          <div className="container_new2 subWapper">
            <div className="ve_main_list">
              <div className="tabn">
                <h1 className="SupplyInfor-cur">货源信息</h1>
                
              </div>
              <div class="intro_xq_addr_box_c">
              <div class="intro_xq_addr_box_x">
              <span class="intro_addr_s"><i></i><em>{this.state.hwInfo.p1}</em></span>
                <div class="intro_addr_m">
                  <span class="ma_blue">直达</span>
                  <i></i>
                  <em style={{width: '202px', textAlign:'left'}}></em>
                  <em class="intro_addr_m_s">要求时效<i>{this.state.hwInfo.time}</i></em>
                </div>
                <span class="intro_addr_z"><i></i><em>{this.state.hwInfo.p2}</em></span>
                </div>
              </div>
              <div class="com_intro_addr">
              <div class="com_intro_addr_box">
                <div class="com_intro_addr_box_l">
                  <div class="business_detail_cont">
                    <p class="com_intro_addr_title">始发地</p>
                    <div class="vehicle_select">
                      <div class="vehicle_select_list">
                        <dl class="business_detail_cont_title">
                          <dt>始发地：</dt>
                          <dd>{this.state.hwInfo.p1}</dd>
                        </dl>
                        {/* <dl class="business_detail_cont_cont">
                          <dt>网点名称：</dt>
                          <dd style={{height: '30px'}}>{this.state.hwInfo.p1.split('/')[1]}</dd>
                        </dl> */}
                        <dl class="business_detail_cont_cont">
                          <dt>详细地址：</dt>
                          <dd style={{height: '30px'}}>{this.state.hwInfo.address}网点</dd>
                        </dl>
                        <dl class="business_detail_cont_cont">
                          <dt>联系电话：</dt>
                          <dd style={{height: '30px'}}>18504135050</dd>
                        </dl>
                      </div>
                      <div class="clear"></div>
                    </div>
                  </div>
                </div>
                <div class="com_intro_addr_box_r">
                  <div class="business_detail_cont">
                    <p class="com_intro_addr_title">到达地</p>
                    <div class="vehicle_select">
                      <div class="vehicle_select_list">
                        <dl class="business_detail_cont_title">
                          <dt>目的地：</dt>
                          <dd>{this.state.hwInfo.p2}</dd>
                        </dl>
                        {/* <dl class="business_detail_cont_cont">
                          <dt>网点名称：</dt>
                          <dd style={{height: '30px'}}>{this.state.hwInfo.p2.split('/')[1]}网点</dd>
                        </dl> */}
                        <dl class="business_detail_cont_cont">
                          <dt>详细地址：</dt>
                          <dd style={{height: '30px',fontSize:'18px',fontWeight:'bold',color:'#e60012'}}>请电询</dd>
                        </dl>
                        {/* <dl class="business_detail_cont_cont">
                          <dt>联系电话：</dt>
                          <dd style={{height: '30px'}}>18604947998 </dd>
                        </dl> */}
                      </div>
                      <div class="clear"></div>
                    </div>
                  </div>
                </div>
                <div class="cleardiv"></div>
              </div>

              <div class="com_zx_pri">
                <div class="com_zx_pri_l com_zd_pri">
                    <p>货物信息</p>
                  </div>
                <div class="com_zx_pri_r com_zd_pri_r">
                <p class="host_city_pri2">
                  <span style={{fontWeight: 'bold'}}>{this.state.hwInfo.p8}</span>
                    <span style={{marginLeft:'20px'}}>
                      <i class="host_city_pri_z2"></i>
                      <span>重货<i>{this.state.hwInfo.p4}</i></span>
                    </span>
                    <span class="host_city_pri_l2">
                      <i class="host_city_pri_p2"></i>
                      <span>泡货<i>{this.state.hwInfo.p6}</i></span>
                    </span><em class="clear"></em>
                  </p>
                  </div>
                <div class="clear"></div>
              </div>

              <div class="com_zx_pri" style={{marginTop:'20px'}}>
                <div class="com_zx_pri_l com_zd_pri">
                    <p>运输价格</p>
                  </div>
                <div class="com_zx_pri_r com_zd_pri_r">
                    <p class="com_zd_pri_d">价格电议</p>
                  </div>
                <div class="clear"></div>
              </div>
            

              <div class="com_addr_f">
                  <div class="com_addr_f_l">
                    <p>货物图片</p>
                  </div>
                  <div class="com_addr_f_r">
                    <p><em></em></p>
                  </div>
                  <div class="clear"></div>
                </div>


                <div class="com_addr_f">
                  <div class="com_addr_f_l">
                    <p>其他要求</p>
                  </div>
                  <div class="com_addr_f_r">
                    <p><em></em></p>
                  </div>
                  <div class="clear"></div>
                </div>
                <div style={{textAlign: 'center'}}>
                  <a
                        href="javascript:void(0)"
                        id="jiedan"
                        onClick={() => {
                          this.orderReceivingHandleClick(this.state.hwInfo);
                        }}
                        className="btn-a"
                      >
                        接单
                      </a></div>
                <div style={{height:'50px'}}></div>
              </div>
              

              
            </div>
          </div>
        </div>
        <div
          id="ulogin"
          style={{
            height: '440px',
            width: '650px',
            position: 'fixed',
            border: '10px solid',
            top: '30%',
            left: 0,
            right: 0,
            background: '#F7F7FC',
            opacity: 1,
            zIndex: 100,
            marginLeft: 'auto',
            marginRight: 'auto',
            display: 'none',
          }}
        >
          <Row
            style={{
              padding: '10px',
              width: '500px',
              margin: '0 auto',
              marginTop: '30px',
              lineHeight: '35px',
            }}
          >
            <Col span={24}>
              <div
                style={{
                  border: '1px solid #e0e0e0',
                  background: '#ebebeb',
                  padding: '8px',
                }}
              >
                <div style={{ background: '#ffffff' }}>
                  <div class="login_form_title">
                    <span>账号登录</span>
                  </div>
                  <div className="login_form_input">
                    <p className="erro_msg" id="message">
                      <span className="im"></span>
                      <span></span>
                    </p>
                    <ul>
                      <li>
                        <label>账号</label>
                        <input
                          type="text"
                          name="account"
                          id="account"
                          className="ant-input login_input"
                          placeholder="登录名/手机号"
                          autocomplete="off"
                        />
                      </li>
                      <li>
                        <label>密码</label>
                        <input
                          type="password"
                          name="password"
                          id="password"
                          className="ant-input login_input"
                          placeholder="请输入密码"
                          autocomplete="off"
                        />
                      </li>
                      <li style={{ textAlign: 'center' }}>
                        <input
                          type="button"
                          style={{
                            height: '42px',
                            width: '150px',
                            marginTop: '30px',
                            background: 'rgb(247, 247, 252)',
                            border: '1px solid rgb(247, 247, 252)',
                            color: 'black',
                          }}
                          id="quxiao"
                          className="mywuda_sub_18"
                          value="取消"
                          onClick={() => {
                            document.getElementById('ulogin').style.display =
                              'none';
                          }}
                        ></input>
                        <input
                          type="button"
                          style={{
                            height: '42px',
                            width: '150px',
                            marginTop: '30px',
                            marginLeft: '20px',
                          }}
                          id="tijiao"
                          className="mywuda_sub_18"
                          value="登录"
                          onClick={() => {
                            this.login();
                          }}
                        ></input>
                      </li>
                      <li style={{ textAlign: 'right' }}>
                        还没有优米拉账号？赶紧
                        <a href="#/register">注册账号</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
        <div
          id="modal"
          style={{
            height: '650px',
            width: '720px',
            position: 'fixed',
            border: '10px solid',
            top: '20%',
            left: 0,
            right: 0,
            background: '#F7F7FC',
            opacity: 1,
            zIndex: 100,
            marginLeft: 'auto',
            marginRight: 'auto',
            display: 'none',
          }}
        >
          <Row
            style={{
              paddingTop: '20px',
              paddingLeft: '20px',
              paddingRight: '20px',
            }}
          >
            <Col span={24} className="g-title" style={{ textAlign: 'left' }}>
              <span
                style={{ fontSize: '20px', color: 'red', paddingLeft: '24px' }}
              >
                接单人：
                <span>{this.state.userInfo ? this.state.userInfo.u : ''}</span>
              </span>
            </Col>
            <Col span={4} className="g-title">
              货主名称：
            </Col>
            <Col span={8} className="t-c">
              {this.state.info.p7}
            </Col>
            <Col span={4} className="g-title">
              货物名称：
            </Col>
            <Col span={8} className="t-c">
              {this.state.info.p8}
            </Col>
          </Row>
          <Row
            style={{
              marginTop: '10px',
              paddingLeft: '20px',
              paddingRight: '20px',
            }}
          >
            <Col span={4} className="g-title">
              出发地：
            </Col>
            <Col span={8} className="t-c">
              {this.state.info.p1}
            </Col>
            <Col span={4} className="g-title">
              到达地：
            </Col>
            <Col span={8} className="t-c">
              {this.state.info.p2}
            </Col>
          </Row>
          <Row
            style={{
              marginTop: '10px',
              paddingLeft: '20px',
              paddingRight: '20px',
            }}
          >
            <Col span={4} className="g-title">
              货物数量：
            </Col>
            <Col span={8} className="t-c">
              {this.state.info.p9}
            </Col>
            <Col span={4} className="g-title">
              货物重量：
            </Col>
            <Col span={8} className="t-c">
              {this.state.info.p3}
            </Col>
          </Row>
          <Row
            style={{
              marginTop: '10px',
              paddingLeft: '20px',
              paddingRight: '20px',
            }}
          >
            <Col span={4} className="g-title">
              货物体积：
            </Col>
            <Col span={8} className="t-c">
              {this.state.info.p5}
            </Col>
            <Col span={4} className="g-title">
              发布时间：
            </Col>
            <Col span={8} className="t-c">
              {this.formatDate()}
            </Col>
          </Row>
          <Row
            style={{
              marginTop: '10px',
              paddingLeft: '20px',
              paddingRight: '20px',
            }}
          >
            <Col span={4} className="g-title">
              <span style={{ color: 'red' }}>*</span>车牌号：
            </Col>
            <Col span={20} className="t-c">
              <input id="chepai" className="ant-input"></input>
            </Col>
          </Row>
          <Row
            style={{
              marginTop: '10px',
              paddingLeft: '20px',
              paddingRight: '20px',
            }}
          >
            <Col span={4} className="g-title">
              车长(米)：
            </Col>
            <Col span={20} className="t-c">
              <input id="chechang" className="ant-input"></input>
            </Col>
          </Row>
          <Row
            style={{
              marginTop: '10px',
              paddingLeft: '20px',
              paddingRight: '20px',
            }}
          >
            <Col span={4} className="g-title">
              载重(吨)：
            </Col>
            <Col span={20} className="t-c">
              <input id="zaizhong" className="ant-input"></input>
            </Col>
          </Row>
          <Row
            style={{
              marginTop: '10px',
              paddingLeft: '20px',
              paddingRight: '20px',
            }}
          >
            <Col span={4} className="g-title">
              体积(m³)：
            </Col>
            <Col span={20} className="t-c">
              <input id="tiji" className="ant-input"></input>
            </Col>
          </Row>
          <Row
            style={{
              marginTop: '10px',
              paddingLeft: '20px',
              paddingRight: '20px',
            }}
          >
            <Col span={4} className="g-title">
              <span style={{ color: 'red' }}>*</span>意向报价：
            </Col>
            <Col span={20} className="t-c">
              <input id="baojia" className="ant-input"></input>
            </Col>
          </Row>
          <Row
            style={{
              marginTop: '30px',
              paddingLeft: '20px',
              paddingRight: '20px',
            }}
          >
            <Col span={24} style={{ textAlign: 'center' }}>
              <Button
                style={{
                  marginRight: '10px',
                  backgroundColor: 'red',
                  color: '#ffffff',
                }}
                onClick={() => {
                  this.submitData();
                }}
              >
                接单
              </Button>
              <Button
                style={{
                  backgroundColor: '#fbc066',
                  color: '#ffffff',
                }}
                onClick={() => {
                  document.getElementById('modal').style.display = 'none';
                }}
              >
                关闭
              </Button>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}
